import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  editButton: {
    description: 'Button to edit tax identifier information',
    defaultMessage: 'Edit',
    id: 'Afj3PT',
  },
});
